export enum MazeGamePhase {
  START = "START",
  PLAYING = "PLAYING",
  WIN = "WIN",
  LOSE = "LOSE",
}
